import { gql } from '@apollo/client';
const REMOVE_PRODUCT_CERTIFICATE = gql `
  mutation RemoveProductCertificate($productCertificateId: ID!) {
    removeProductCertificate(productCertificateId: $productCertificateId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_CERTIFICATE;
